<template>
  <div class="p-users-access-schemes-item">
    <v-row class="px-4">
      <v-col>
        <div class="p-header-2">{{ scheme.name }}</div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col v-if="hasAccess()" class="text-right">
        <v-menu bottom left offset-y min-width="200px">
          <template v-slot:activator="{ on: menu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn icon v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('actions') }}</span>
            </v-tooltip>
          </template>

          <v-list dense>
            <v-list-item disabled>
              <v-list-item-icon>
                <v-icon small>mdi-content-copy</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t('copy') }}</v-list-item-content>
            </v-list-item>

            <v-list-item @click="onSchemeEditClick(scheme)">
              <v-list-item-icon>
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t('edit') }}</v-list-item-content>
            </v-list-item>

            <v-list-item @click="onSchemeDeleteClick(scheme)">
              <v-list-item-icon>
                <v-icon small>mdi-delete-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ $t('delete') }}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="tableHeaders"
          :items="scheme.users"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="p-no-borders"
          hide-default-footer
        >
          <template v-slot:[`item.userId`]="{ item }">
            <p-user-item
              :value="managerById(item.userId)"
              font-bold
              you
            ></p-user-item>
          </template>
          <template v-slot:[`item.budgetClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.budgetClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
          <template v-slot:[`item.documentDocumentClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.documentDocumentClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
          <template v-slot:[`item.documentContractClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.documentContractClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
          <template v-slot:[`item.documentScheduleClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.documentScheduleClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
          <template v-slot:[`item.eventClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.eventClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
          <template v-slot:[`item.marketingPostClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.marketingPostClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
          <template v-slot:[`item.memberClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.memberClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
          <template v-slot:[`item.todoClaim`]="{ item }">
            <scheme-access-switcher
              v-model="item.todoClaim"
              @input="updateAccessClaim($event, scheme, item)"
            ></scheme-access-switcher>
          </template>
        </v-data-table>

        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="15"
          class="mt-5"
        ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

import PUserItem from '@/components/PUserItem'

import SchemeAccessSwitcher from './SchemeAccessSwitcher'

import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PUserItem,
    SchemeAccessSwitcher
  },


  mixins: [
    snackbarMixin,
    pageMixin,
    accessMixin
  ],

  props: {
    scheme: Object
  },


  data () {
    return {
      page: 1,
      itemsPerPage: 5
    }
  },


  computed: {
    ...mapGetters('scheme', ['schemes']),
    ...mapGetters('user', ['managers', 'managerById']),

    pageCount () {
      return Math.ceil(this.scheme?.users?.length / this.itemsPerPage)
    },

    accessOptions () {
      return [
        { value: true, text: this.$t('scheme.accessOptions.write') },
        { value: false, text: this.$t('scheme.accessOptions.read') }
      ]
    },

    tableHeaders () {
      return [
        { text: this.$t('scheme.table.name'), value: 'userId' },
        { text: this.$t('scheme.table.budget'), value: 'budgetClaim', sortable: false, filterable: false },
        { text: this.$t('scheme.table.documentDocument'), value: 'documentDocumentClaim', sortable: false, filterable: false },
        { text: this.$t('scheme.table.documentContract'), value: 'documentContractClaim', sortable: false, filterable: false },
        { text: this.$t('scheme.table.documentSchedule'), value: 'documentScheduleClaim', sortable: false, filterable: false },
        { text: this.$t('scheme.table.events'), value: 'eventClaim', sortable: false, filterable: false },
        { text: this.$t('scheme.table.marketingPost'), value: 'marketingPostClaim', sortable: false, filterable: false },
        { text: this.$t('scheme.table.member'), value: 'memberClaim', sortable: false, filterable: false },
        { text: this.$t('scheme.table.todos'), value: 'todoClaim', sortable: false, filterable: false }
      ]
    }
  },


  methods: {
    ...mapActions('scheme', ['loadSchemeUser', 'updateSchemeUser']),

    onSchemeEditClick (scheme) {
      this.$emit('editScheme', scheme)
    },

    onSchemeDeleteClick (scheme) {
      this.$emit('deleteScheme', scheme)
    },

    async updateAccessClaim (value, scheme, schemeUser) {
      try {
        this.showSnackbarProcessing()
        await this.updateSchemeUser({ schemeId: scheme.id, schemeUser: schemeUser })
        this.showSnackbarSuccess(this.$t('saved'))
      } catch (error) {
        this.showSnackbarError()
        this.reloadSchemeUser(scheme.id, schemeUser.userId)
        this.$log.error(error)
      }
    },

    async reloadSchemeUser (schemeId, userId) {
      try {
        await this.loadSchemeUser({ schemeId, userId })
      } catch (error) {
        this.$log.error(error)
      }
    }
  }
}
</script>
